import { createAction } from 'redux-actions';

export const MESSAGE_SHOW = 'MESSAGE_SHOW';
export const MESSAGE_HIDE = 'MESSAGE_HIDE';

export const show = createAction(MESSAGE_SHOW, (taskId, txt, op, parameters) => ({
  taskId,
  txt,
  op,
  parameters,
}));
export const hide = createAction(MESSAGE_HIDE);
